import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import App from './App';
import './index.css';
import { store } from "./store";
import 'react-nice-scroll/dist/styles.css'

// Добавляет метатеги для разработки
function Application() {
    return (
        <div className="application">
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
                <title>Оптиктория Управление</title>
            </Helmet>
        </div>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

export default Application;
